import { Component, Input, OnInit } from '@angular/core';
import { Expertise } from '../../../../domain/expertise/expertise.domain';

@Component({
    selector: 'app-expertise-certificates',
    templateUrl: './expertise-certificates.component.html',
    styleUrls: ['./expertise-certificates.component.scss']
})
export class ExpertiseCertificatesComponent implements OnInit {

    @Input() expertise: Expertise;

    constructor() {
    }

    ngOnInit() {
    }

}
